export default __webpack_public_path__ + "static/media/FreteBlack.9c698781.svg";